import {Action, handleActions, ReducerMap} from "redux-actions";
import {IPlanInfo} from "../../../model/ClientsAndPlans.model";
import {throwErrorOnNullOrUndefined} from "../../../utils/errorUtil";
import {
    NavigationTab,
} from "../../../utils/navigationUtils";
import {updateCurrentPlan} from "../../../utils/sessionUtil";
import {reloadPage} from "../../../api/BrowserWrapper";
import {HeaderActions} from "./HeaderActions";

export enum NotificationTypes {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
}

export interface INotificationObject {
    message: string;
    notificationType: NotificationTypes;
}

export interface IHeaderReducerState {
    hasResearchAccess?: boolean | undefined;
    showUsernameMenu: boolean;
    currentNavigationTab?: NavigationTab;
    notificationObject?: INotificationObject;
}

export const initialState: IHeaderReducerState = {
    showUsernameMenu: false,
    notificationObject: undefined,
};

const reducerMap = {
    [HeaderActions.SET_MENU_VISIBILITY]: (state: IHeaderReducerState,
                                          action: Action<boolean>): IHeaderReducerState => {
        return {...state, showUsernameMenu: throwErrorOnNullOrUndefined(action.payload)};
    },
    [HeaderActions.SET_CURRENT_PLAN]: (state: IHeaderReducerState,
                                       action: Action<IPlanInfo>): IHeaderReducerState => {
        updateCurrentPlan(throwErrorOnNullOrUndefined(action.payload));
        reloadPage();
        return {...state};
    },
    [HeaderActions.SET_CURRENT_NAVIGATION_TAB]: (state: IHeaderReducerState,
                                                 action: Action<NavigationTab>): IHeaderReducerState => {
        return {...state, currentNavigationTab: action.payload!};
    },
    [HeaderActions.SET_HEADER_NOTIFICATION]: (state: IHeaderReducerState,
                                              action: Action<INotificationObject>): IHeaderReducerState => {
        return {...state, notificationObject: action.payload};
    },
    [HeaderActions.CLEAR_HEADER_NOTIFICATION]: (state: IHeaderReducerState): IHeaderReducerState => {
        return {...state, notificationObject: undefined};
    },
};

type HeaderTypes = string | boolean | {location: { pathname: string }} | INotificationObject | IPlanInfo;

// redux-actions' ReducerMap types every handler's action as Action<HeaderTypes>, but each
// handler here narrows to a specific payload type; cast to satisfy the uniform map signature.
export default handleActions<IHeaderReducerState, HeaderTypes>(
    reducerMap as unknown as ReducerMap<IHeaderReducerState, HeaderTypes>,
    initialState,
);
